import React, { useState, useEffect } from 'react'
import api from '../../api/axios'
import styles from './UserForm.module.css'
import { useContent } from '../../content/ContentProvider'

export function UserForm({ user, onSubmit, isLoading }) {
  const { t } = useContent()
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    companyId: '',
    role: 'USER',
    enabled: true,
  })
  const [companies, setCompanies] = useState([])

  useEffect(() => {
    fetchCompanies()
  }, [])

  useEffect(() => {
    if (user) {
      setFormData({
        username: user.username || '',
        email: user.email || '',
        companyId: user.company?.id || user.companyId || '',
        role: user.role || 'USER',
        enabled: user.enabled !== undefined ? user.enabled : true,
      })
    }
  }, [user])

  const fetchCompanies = async () => {
    try {
      const response = await api.get('/api/admin/companies?size=100')
      const data = response.data
      setCompanies(Array.isArray(data) ? data : data.content || [])
    } catch (err) {
      console.error('Failed to fetch companies:', err)
    }
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(formData)
  }

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <div className={styles.field}>
        <label>{t('users.form.username.label')}</label>
        <input
          type="text"
          name="username"
          value={formData.username}
          onChange={handleChange}
          required
          disabled={isLoading}
        />
      </div>

      <div className={styles.field}>
        <label>{t('users.form.email.label')}</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          disabled={isLoading}
        />
      </div>

      <div className={styles.row}>
        <div className={styles.field}>
          <label>{t('users.form.company.label')}</label>
          <select
            name="companyId"
            value={formData.companyId}
            onChange={handleChange}
            required
            disabled={isLoading}
          >
            <option value="">{t('users.form.company.placeholder')}</option>
            {companies.map((company) => (
              <option key={company.id} value={company.id}>
                {company.name}
              </option>
            ))}
          </select>
        </div>
        <div className={styles.field}>
          <label>{t('users.form.role.label')}</label>
          <select
            name="role"
            value={formData.role}
            onChange={handleChange}
            disabled={isLoading}
          >
            <option value="USER">{t('users.form.role.user')}</option>
            <option value="ADMIN">{t('users.form.role.admin')}</option>
            <option value="MANAGER">{t('users.form.role.manager')}</option>
          </select>
        </div>
      </div>

      <div className={styles.field}>
        <label className={styles.checkboxLabel}>
          <input
            type="checkbox"
            name="enabled"
            checked={formData.enabled}
            onChange={handleChange}
            disabled={isLoading}
          />
          <span>{t('users.form.enabled.label')}</span>
        </label>
      </div>

      <div className={styles.actions}>
        <button type="submit" disabled={isLoading} className={styles.submitBtn}>
          {isLoading ? t('users.form.saving') : t('users.form.submit')}
        </button>
      </div>
    </form>
  )
}
